import { render, staticRenderFns } from "./Autres.vue?vue&type=template&id=f30a3f1c"
import script from "./Autres.vue?vue&type=script&lang=ts"
export * from "./Autres.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports